import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { InventarioRptComponent } from './inventario-rpt.component';

const routes: Routes = [
  { path: '', component: InventarioRptComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventarioRptRoutingModule { }
